import React from 'react';
import { Helmet } from 'react-helmet-async';

interface EventData {
  name: string;
  description: string;
  startDate: string;
  endDate?: string;
  location?: string;
  organizer?: string;
  image?: string;
  url?: string;
  price?: string;
}

interface EventStructuredDataProps {
  events: EventData[];
}

const EventStructuredData: React.FC<EventStructuredDataProps> = ({ events }) => {
  const siteUrl = 'https://www.hsv-adlershof.berlin';
  
  const eventSchemas = events.map(event => ({
    "@context": "https://schema.org",
    "@type": "Event",
    "name": event.name,
    "description": event.description,
    "startDate": event.startDate,
    "endDate": event.endDate || event.startDate,
    "location": {
      "@type": "Place",
      "name": event.location || "HSV Berlin-Adlershof e.V.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Birkenweg",
        "addressLocality": "Berlin",
        "addressRegion": "Berlin",
        "postalCode": "12439",
        "addressCountry": "DE"
      }
    },
    "image": event.image ? `${siteUrl}${event.image}` : `${siteUrl}/images/common/HSV_Logo.jpg`,
    "url": event.url ? `${siteUrl}${event.url}` : `${siteUrl}/termine`,
    "organizer": {
      "@type": "Organization",
      "name": event.organizer || "HSV Berlin-Adlershof e.V.",
      "url": siteUrl
    },
    "offers": event.price ? {
      "@type": "Offer",
      "price": event.price,
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "url": event.url ? `${siteUrl}${event.url}` : `${siteUrl}/termine`
    } : undefined,
    "eventStatus": "https://schema.org/EventScheduled",
    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode"
  }));

  return (
    <Helmet>
      {eventSchemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default EventStructuredData;